import * as types from 'constants/actionTypes';
import * as operationsApi from 'api/operationsApi';
import { beginAjaxCall, ajaxCallError } from './ajaxCallActions.js';

export function getJobCategories() {
  return function(dispatch) {
    dispatch(beginAjaxCall());
    return operationsApi
      .getJobCategories()
      .then(
        response => dispatch(getJobCategoriesSuccess(response)),
        error => dispatch(ajaxCallError())
      );
  };
}

function getJobCategoriesSuccess(response) {
  return {
    type: types.GET_JOB_CATEGORIES_SUCCESS,
    jobCategories: response.data || []
  };
}
